export default "__VITE_ASSET__c77ed47e__"